<atlas-modal [size]="modalSize" [headerRef]="headerTemplate" [contentRef]="contentTemplate" [showDialogActions]="false">
</atlas-modal>
<ng-template #headerTemplate>
  <div class='terms-of-use terms-and-conditions-modal-header'>

    <h4>Terms & Conditions</h4>
    <atlas-icon class="dsp-print-icon" (click)="termsAndConditions('termsAndConditionDivId')" icon="print"
      [size]="'large'" collection="technology-solid">
    </atlas-icon>
  </div>
</ng-template>
<ng-template #contentTemplate>
  <div id="termsAndConditionDivId" [innerHTML]="terms$ | async"></div>
  <form [formGroup]="form" (keyup.enter)="form.valid && onAgree()">
    <div class="row mos-o-form-row terms-agreement-row">
      <div class="column small-12 terms-agreement-col">
        <atlas-checkbox [isChecked]="form.get('agreement')?.value" checkboxId="agreement" checkboxName="agreement"
          labelTypography="typographyStyles-body-medium" (onChange)="onAgreementChange($event)">
          I accept the agreement.
        </atlas-checkbox>
      </div>
    </div>
    <div class="row mos-u-spacer--padding-bottom-md terms-actions-row">
      <div class="small-12 columns terms-actions-col">
        <atlas-button id="button-accept-terms" [style]="'strong'" [color]="'brand'" [size]="'medium'"
          (click)="onAgree()" [disabled]="form.invalid || !form.get('agreement')?.value">Accept
        </atlas-button>
      </div>
    </div>
  </form>
</ng-template>